export class DataCache {

  static Quick = 60 * 1000;
  static Short = 60 * 60 * 1000;
  static Medium = 24 * 60 * 60 * 1000;
  static Long = 30 * 24 * 60 * 60 * 1000;
  static VeryLong = 365 * 24 * 60 * 60 * 1000;
  static Infinite = 1000 * 365 * 24 * 60 * 60 * 1000;

  constructor() {}

  static sessionId () {
    const sessionId = localStorage.getItem('@sessionId');

    if (!sessionId) {
      localStorage.setItem('@sessionId', Math.random().toString(36).substring(2, 15));
    }

    return localStorage.getItem('@sessionId');
  }

  static set<T> (key: string, data: T, ttl: number) {
    const exp = Date.now() + ttl;

    localStorage.setItem(key, JSON.stringify({ data, exp, sessionId: this.sessionId() }));
  }

  static get<T> (key: string): T | null {
    const item = localStorage.getItem(key);
    if (!item) return null;

    try {
      const { data, exp, sessionId } = JSON.parse(item);

      if (exp < Date.now() || sessionId !== this.sessionId()){
        localStorage.removeItem(key);
        return null;
      }

      return data;
    } catch (e) {
      localStorage.removeItem(key);
      return null;
    }
  }

  static clear () {
    localStorage.clear();
    localStorage.setItem('@sessionId', Math.random().toString(36).substring(2, 15));
  }
  
}
